import { API_ERRORS } from 'tradera/utils/api';
import { reload } from 'tradera/utils/location';
import {
    handleCategoryListError,
    receiveCategoryList,
    requestCategoryList
} from 'tradera/state/categories/reducer';
import { touchWebClient } from 'tradera/utils/http';

export const fetchCategoryList = () => (dispatch) => {
    dispatch(requestCategoryList());

    return touchWebClient
        .get('categories', { cancelTokenId: 'getCategoryList' })
        .then((results) => dispatch(receiveCategoryList(results.data)))
        .catch((error) => {
            switch (error.message) {
                case API_ERRORS.VERSION_MISMATCH:
                    reload(true);
                    break;
                case API_ERRORS.CANCELLED:
                    break;
                default:
                    dispatch(handleCategoryListError(error));
                    break;
            }
        });
};
